import { Typography } from '@mui/material';
import { ConfirmModal } from 'shared/modals/confirmModal';

import MDBox from 'components/MDBox';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';

const propTypes = {
  isOpened: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  fileToDelete: PropTypes.string,
};

const ConfirmDeleteModal = ({
  isOpened,
  onConfirm,
  onCancel,
  fileToDelete,
}) => {
  return (
    <ConfirmModal
      isOpened={isOpened}
      title={intl.get('new_modal_to_be_removed')}
      onConfirm={onConfirm}
      bodyText={`${intl.get('new_modal_confirm_to_be_removed_body')}`}
      confirmButtonText={intl.get('new_modal_confirm_to_be_removed')}
      onCancel={onCancel}
      cancelButtonText={intl.get('new_modal_cancel_to_be_removed')}>
      <MDBox
        data-testid="modal-child-box"
        sx={{ marginTop: '-10px', maxWidth: 'md' }}>
        <Typography variant="h6">{fileToDelete}</Typography>
      </MDBox>
    </ConfirmModal>
  );
};

ConfirmDeleteModal.propTypes = propTypes;

export default ConfirmDeleteModal;
